import { tableHooks } from 'components/Table'
import { features, statuses } from 'keys'
import { affiliationCell, fileUploadedCell, learningUnitCell, markingAudioByCell, markingByCell, markingDateCell, markingDurationCell, markingEndDateCell, markingStartDateCell, percentageAccuracyCell, roleStatusCell, statusType, statusTypeCell, stuckDateCell, stuckReasonCell, useBackToMarkingCell, useCloneAssessmentForLearning, useCloneAssessmentForLearningCell, useGoAssessmentCell, useGoClassificationCell, useReleaseStuckCell, useTrainingAssessmentComparisonCell, useVersionsCell, useViewAssessmentCell, usevVersionsCell } from './useColumns'
import { markingWordsHooks } from '..'
import { useContext } from 'react'
import { AbilityContext } from 'components/Permissions/Can'

const useTabs = () => {
    const { wordsAiInProgress, inProgress, aiFailed, redo, aiPending, recheckPending, wordsComplete, wordsInProgress, uploaded, backToMarking } = statuses

    const ability = useContext(AbilityContext)
    const isSuperUser = ability.can("manage", "super-user")

    const idCell = tableHooks.useIdCell()
    const testTakerNameCell = tableHooks.useTestTakerNameCell()
    const assessmentNameCell = tableHooks.useAssessmentNameCell()
    const gradeOfAllocationCell = tableHooks.useGradeOfAllocationCell()
    const playCell = tableHooks.usePlayCell()
    const goAssessmentCell = useGoAssessmentCell()
    const backToMarkingCell = useBackToMarkingCell()
    const viewAssessmentCell = useViewAssessmentCell()
    const versionsCell = useVersionsCell()
    const trainingAssessmentComparisonCell = useTrainingAssessmentComparisonCell()
    const cloneAssessmentForLearningCell = useCloneAssessmentForLearningCell()
    const versionColumns = markingWordsHooks.useVersionColumns()
    const isTraining = markingWordsHooks.useIsTraining()
    const releaseStuckCell = useReleaseStuckCell()


    const assessmentAcivityTab = {
        id: 0,
        label: "פעילות מבדקים",
        filters: {
            workflowState: "assessment_activity"
        },
        columns: [
            idCell,
            roleStatusCell,
            markingByCell,
            assessmentNameCell,
            learningUnitCell,
            testTakerNameCell,
            gradeOfAllocationCell,
            affiliationCell,
            fileUploadedCell,
            markingDateCell,
            markingAudioByCell,
            goAssessmentCell,
            playCell
        ],
        sortBy: {
            fields: "file_uploaded_date,marking_words_start_date,marking_words_last_update_date",
            desc: false
        },
        feature: features.assessments_activity__tab
    }

    let tabs = [
        {
            id: 1,
            label: "ממתינים לסימון",
            filters: {
                status: [uploaded, backToMarking],
                sub_status: [],
                exclude_sub_status: [],
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                learningUnitCell,
                gradeOfAllocationCell,
                affiliationCell,
                fileUploadedCell,
                markingAudioByCell,
                goAssessmentCell,
                playCell
            ],
            sortBy: {
                desc: false,
                fields: "file_uploaded_date"
            },
        },
        // {
        //     id: 3,
        //     label: "ממתינים לסימון אחרי AI",
        //     filters: {
        //         status: [inProgress],
        //         sub_status: [aiPending],
        //     },
        //     columns: [
        //         idCell,
        //         assessmentNameCell,
        //         percentageAccuracyCell,
        //         testTakerNameCell,
        //         learningUnitCell,
        //         gradeOfAllocationCell,
        //         affiliationCell,
        //         markingByCell,
        //         markingDurationCell,
        //         markingStartDateCell,
        //         markingEndDateCell,
        //         viewAssessmentCell,
        //         backToMarkingCell,
        //         playCell
        //     ],
        //     sortBy: {
        //         desc: true,
        //         id: "marking_words_end_date"
        //     }
        // },
        {
            id: 2,
            label: "בסימון",
            filters: {
                status: [inProgress],
                sub_status: [wordsInProgress],
                exclude_sub_status: [],
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                learningUnitCell,
                gradeOfAllocationCell,
                affiliationCell,
                fileUploadedCell,
                markingDateCell,
                markingByCell,
                markingAudioByCell,
                viewAssessmentCell,
                playCell
            ],
            sortBy: {
                desc: false,
                fields: "file_uploaded_date"
            },
        },
        // {
        //     id: 3,
        //     label: "בסימון AI",
        //     filters: {
        //         status: [inProgress],
        //         sub_status: [wordsAiInProgress],
        //     },
        //     columns: [
        //         idCell,
        //         assessmentNameCell,
        //         percentageAccuracyCell,
        //         testTakerNameCell,
        //         learningUnitCell,
        //         gradeOfAllocationCell,
        //         affiliationCell,
        //         markingByCell,
        //         markingDurationCell,
        //         markingStartDateCell,
        //         markingEndDateCell,
        //         viewAssessmentCell,
        //         backToMarkingCell,
        //         playCell
        //     ],
        //     sortBy: {
        //         desc: true,
        //         id: "marking_words_end_date"
        //     }
        // },
        {
            id: 3,
            label: "ממתין לבקרה",
            filters: {
                workflowState: "recheck_pending"
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                learningUnitCell,
                gradeOfAllocationCell,
                affiliationCell,
                markingByCell,
                markingDurationCell,
                markingStartDateCell,
                markingEndDateCell,
                viewAssessmentCell,
                backToMarkingCell,
                versionsCell,
                playCell
            ],
            sortBy: {
                desc: true,
                fields: "marking_words_end_date"
            }
        },
        {
            id: 4,
            label: "סימון הסתיים",
            filters: {
                status: [inProgress],
                sub_status: [wordsComplete],
                exclude_sub_status: [],
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                learningUnitCell,
                gradeOfAllocationCell,
                affiliationCell,
                markingByCell,
                markingAudioByCell,
                markingDurationCell,
                markingStartDateCell,
                markingEndDateCell,
                viewAssessmentCell,
                backToMarkingCell,
                isTraining ? trainingAssessmentComparisonCell : versionsCell,
                cloneAssessmentForLearningCell,
                playCell
            ],
            sortBy: {
                desc: true,
                fields: "marking_words_end_date"
            },
            collapseColumns: isTraining ? null : versionColumns
        },
        {
            id: 5,
            label: "לביצוע חוזר",
            filters: {
                status: [redo],
                sub_status: [],
                exclude_sub_status: [recheckPending],
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                statusTypeCell,
                markingByCell,
                goAssessmentCell,
                playCell
            ],
            sortBy: {
                desc: true,
                fields: "marking_words_end_date"
            }
        },
        {
            id: 6,
            label: "מבדקים תקועים",
            filters: {
                workflowState: "stuck"
            },
            columns: [
                idCell,
                assessmentNameCell,
                testTakerNameCell,
                learningUnitCell,
                gradeOfAllocationCell,
                affiliationCell,
                stuckReasonCell,
                stuckDateCell,
                markingByCell,
                viewAssessmentCell,
                releaseStuckCell,
                playCell
            ],
            sortBy: {
                desc: true,
                id: "stuck_date"
            }
        },
        // {
        //     id: 3,
        //     label: "נכשל בפענוח AI",
        //     filters: {
        //         status: [inProgress],
        //         sub_status: [aiFailed],
        //     },
        //     columns: [
        //         idCell,
        //         assessmentNameCell,
        //         percentageAccuracyCell,
        //         testTakerNameCell,
        //         learningUnitCell,
        //         gradeOfAllocationCell,
        //         affiliationCell,
        //         markingByCell,
        //         markingDurationCell,
        //         markingStartDateCell,
        //         markingEndDateCell,
        //         viewAssessmentCell,
        //         backToMarkingCell,
        //         playCell
        //     ],
        //     sortBy: {
        //         desc: true,
        //         id: "marking_words_end_date"
        //     }
        // },
    ]

    return isSuperUser ? [assessmentAcivityTab, ...tabs] : tabs
}



export default useTabs
